import { render, staticRenderFns } from "./AvailableBoard.vue?vue&type=template&id=6ff321ed&scoped=true"
import script from "./AvailableBoard.vue?vue&type=script&lang=js"
export * from "./AvailableBoard.vue?vue&type=script&lang=js"
import style0 from "./AvailableBoard.vue?vue&type=style&index=0&id=6ff321ed&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff321ed",
  null
  
)

export default component.exports